import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'error' },
  {
    path: 'error',
    loadComponent: () =>
      import('./views/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent
      ),
  },
  {
    path: 'static-page/:pageSlug',
    loadComponent: () =>
      import('./views/static-pages/static-pages.component').then(
        (m) => m.StaticPagesComponent
      ),
  },
  {
    path: 'meals',
    loadChildren: () =>
      import('./views/meal/meal.module').then((m) => m.MealModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'my-account',
    loadComponent: () =>
      import('@views/account/account.component').then(
        (m) => m.AccountComponent
      ),
  },
  {
    path: ':shopId/ticket/:orderId',
    loadComponent: () =>
      import('./views/ticket/ticket.component').then((m) => m.TicketComponent),
  },
  // Avoid putting routes below this route to avoid routing issues due to param as path
  // TODO: change path
  {
    path: ':shopId',
    loadComponent: () =>
      import('./views/restaurant/restaurant.component').then(
        (m) => m.RestaurantComponent
      ),
  },
  { path: '**', redirectTo: 'error' },
];
